module.exports = __webpack_public_path__ + "img/history-v2.cf65ac1b.png";